import { AtivoAlavancagemModel } from './AtivoAlavancagemModel';
import { AtivoAlvoModel as ObjetivoAlvoModel } from './AtivoAlvoModel';

export class AtivoModel {
  id: Number
  comentario: String
  codigo_ativo: String
  codigo_ativo_objeto: String
  dolar: String
  encerrada: Boolean
  nome_ativo: String
  compra: Number
  ativo_objeto: any;
  logo: String
  data_entrada: String
  created_at: string;
  data_saida: String
  grafico_img: String
  preco: String
  entrada_limite: String
  resultado: String
  objetivo: String
  objetivo_estrutura: Number
  objetivo_pct: String
  stop: String
  stop_pct: String
  deu_lucro: Boolean
  gr_entrada: Number
  gr_objetivo: Number
  gr_stop: Number
  gr_timeframe: String
  gr_date: String
  preco_atual: number;
  viewEstadoCor: boolean;
  variacao: number;
  decimal_places: number;
  objetivos: Array<ObjetivoAlvoModel> = []
  favorito = false
  pontas=[]
  tipoObjetivo: String
  tipoStop: String
  atingido: Boolean
  alavancagem: AtivoAlavancagemModel
  saida: number
  url_printscreen_pnt: String
  url_printscreen_profit: String

  public static TIPO_COMPRA: String = "compra"
  static TIPO_VENDA: String = "venda"
  static TIPO_ENCERRADAS: String = "encerrados"

  static STATUS_ABERTO: String = 'aberto'
  static STATUS_ENCERRADO: String = 'encerrado'

  public static getDataAtivo(dataAtivo: String) {
    if (dataAtivo != null) {
      let dataSplit = dataAtivo.split(' ')[0].split('-')
      return dataSplit[2] + '/' + dataSplit[1] + '/' + dataSplit[0]
    }
    return ''
  }

  public static getHoraAtivo(dataAtivo: String) {
    if (dataAtivo != null) {
      let dataSplit = dataAtivo.split(' ')[1].split(':')
      return dataSplit[0] + ':' + dataSplit[1]
    }
    return ''
  }
}